import * as React from "react";
import { FormattedMessage } from "react-intl";

import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { User } from "../../api";
import { getAvailableUsername } from "../../project-utils";
import { hasToAcceptContract } from "../../project-utils/permissions";
import { Communication } from "../../redux/ducks";
import PermissionGuard from "../atoms/PermissionGuard";
import withToggle, { InjectedToggleProps } from "../hocs/withToggle";
import ContractContent from "./ContractContent";

interface ContractProps {
  onAccept: () => void;
  onDismiss: () => void;
  isOpen: boolean;
  teacher: User;
  student: User;
}

type Props = ContractProps & Communication & InjectedToggleProps;

const Contract: React.SFC<Props> = ({
  onAccept,
  onDismiss,
  isOpen,
  fetching,
  isActive,
  toggle,
  teacher,
  student,
}) => {
  const phrasing = {
    accept: <FormattedMessage id={"buttonActions.agree"} />,
    notNow: <FormattedMessage id={"buttonActions.notNow"} />,
  };

  return (
    <Dialog keepMounted={false} open={isOpen} scroll={"body"}>
      <DialogTitle>
        <FormattedMessage id={"contract.coachingContractTitle"} />
      </DialogTitle>
      <DialogContent>
        {(teacher || student) && (
          <ContractContent
            teacherName={getAvailableUsername(teacher)}
            studentName={getAvailableUsername(student)}
          />
        )}
      </DialogContent>
      <DialogContent>
        <FormControlLabel
          control={<Checkbox checked={isActive} onChange={toggle} />}
          label={<FormattedMessage id={"generic.iAgreeWithTheContract"} />}
        />
      </DialogContent>
      <DialogActions>
        <PermissionGuard check={hasToAcceptContract} invert>
          <Button onClick={onDismiss} color={"primary"}>
            {phrasing.notNow}
          </Button>
        </PermissionGuard>
        <Button disabled={!isActive} onClick={onAccept} color={"primary"}>
          {fetching ? <CircularProgress size={20} /> : phrasing.accept}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withToggle(Contract);



// WEBPACK FOOTER //
// ./src/components/molecules/Contract.tsx